module.exports = __webpack_public_path__ + "img/1997pigc.a8051a05.png";